// extracted by mini-css-extract-plugin
export default {"wrap":"gift-card-history-section_wrap__p2nWl","title":"gift-card-history-section_title__jU7Ep"};